var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseLink',{staticClass:"zetta__logo",attrs:{"tag":"a","path":"/"}},[_c('img',{staticClass:"zetta__logo-pic",attrs:{"src":require("@/assets/images/logo-zetta.png"),"alt":"Логотип Zetta"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }